import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seja-nosso-parceiro-page',
  templateUrl: './seja-nosso-parceiro-page.component.html',
  styleUrls: ['./seja-nosso-parceiro-page.component.scss']
})
export class SejaNossoParceiroPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
